export const chunkArray = <T>(arr: T[], length: number): T[][] => {
  const matrix: T[][] = []

  for (let i = 0; i < arr.length; i += length) {
    matrix.push(arr.slice(i, i + length))
  }

  return matrix
}
